/**
 * Base path where the therapy demo is mounted in the parent app.
 *
 * This is the ONE place you change if you ever move the demo to a
 * different route. Every internal <Link> in the therapy components
 * imports this and prepends it.
 *
 * If you remount the demo at, say, "/demos/harbor-therapy", just
 * change this constant — nothing else needs to be touched.
 */
export const BASE = "/portfolio/practice";

/**
 * Helper for building paths inside the demo.
 *   path("about")     → "/portfolio/business-demo/about"
 *   path("/about")    → "/portfolio/business-demo/about"  (handles either form)
 *   path("")          → "/portfolio/business-demo"        (the demo home)
 */
export const path = (sub = "") => {
    if (!sub) return BASE;
    return `${BASE}/${sub.replace(/^\/+/, "")}`;
};